
export const FETCH_USERS = 'fetchUsers'
export const FETCH_ROLES = 'fetchRoles'
export const FETCH_EQUIPMENTS = 'fetchEquipments'
export const FETCH_QUIZ_DETAILS =   'fetchQuizDetails'
export const FETCH_INDIVIDUAL_USER = 'fetchIndividualUser'
export const FETCH_INDIVIDUAL_EQUIPMENT =  'fetchIndividualEquipment'
export const FETCH_INDIVIDUAL_GROUP = 'fetchIndividualGroup'
export const FETCH_INDIVIDUAL_PAGE  =   'fetchIndividualPage'
export const FETCH_USER_DOCUMENTS  =   'fetchUserDocuments'
export const FETCH_INVOICES = 'fetchInvoices'
export const FETCH_GROUPS = 'fetchGroups'
export const FETCH_QUIZ_DATA = 'fetchQuizData'
export const FETCH_LANGUAGES    =   'fetchLanguages'
export const FETCH_PAGES = 'fetchPages'
export const CONTACT_QUERY   =   'contactQuery'
export const AUTO_RENEWAL_OFF = 'autoRenewalOff'
export const FETCH_STRIPE_SECRET_KEY = 'fetchStripeSecretKey'
export const SET_STRIPE_CARD = 'setStripeCard'
export const UPLOAD_USERS_CSV = 'uploadUsersCSV'
export const FORGOT_PASSWORD = 'forgotPassword'
export const FETCH_NAVIGATION_BAR_STATUS = 'fetchNavigationBarStatus'
export const UPDATE_USER_STATUS = 'updateUserStatus'
export const CHECK_TOKEN = 'checkToken'
export const UPDATE_PASSWORD = 'updatePassword'
export const ADD_USER = 'addUser'
export const ADD_GROUP = 'addGroup'
export const ADD_EQUIPMENT = 'addEquipment'
export const UPDATE_EQUIPMENT = 'updateEquipment'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const CHECK_AUTH = 'checkAuth'
export const DOWNLOAD_DOCUMENT  =   'downloadDocument'
export const SAVE_USER_SLIDE_ID = 'saveUserSlideID'
export const UPDATE_USER = 'updateUser'
export const DELETE_USER = 'deleteUser'
export const UPDATE_GROUP = 'updateGroup'
export const DELETE_GROUP = 'deleteGroup'
export const DELETE_EQUIPMENT = 'deleteEquipment'
export const DELETE_CARD = 'deleteCard'
export const FETCH_STRIPE_ALL_CARDS ='fetchStripeCards'
export const RESET_STATE    =   'resetState'
export const PAGES_RESET_STATE = "resetPagesState"
export const USERS_RESET_STATE  = 'resetUsersState'
export const STRIPE_RESET_STATE = "resetStripeState"
export const LANGUAGES_RESET_STATE  =   'resetLanguagesState'
export const EQUIPMENTS_RESET_STATE  =   'resetEquipmentsState'
export const GROUPS_RESET_STATE  =   'resetGroupsState'
export const ROLES_RESET_STATE  =   'resetRolesState'
export const GLOBALS_RESET_STATE   =   'resetGlobalsState'
export const FETCH_COURSES = 'fetchCourses'
export const FETCH_MODULES = 'fetchModules'
export const FETCH_INDIVIDUAL_MODULE = 'fetchIndividualModule'
export const COURSE_SUBSCRIBE = 'subscribeCourse'
export const FETCH_MODULE_PLAYER = 'fetchModulePlayer'
export const FETCH_GENERAL_DOCUMENTS    =   'fetchGeneralDocuments'
export const FETCH_PERSONAL_DOCUMENTS    =   'fetchPersonalDocuments'
export const DOWNLOAD_GENERAL_DOCUMENT  =   'downloadGeneralDocument'
export const DOWNLOAD_PERSONAL_DOCUMENT  =   'downloadPersonalDocument'
export const UPDATE_USER_DOCUMENT  =   'updateUserDocument'
export const DOWNLOAD_USER_DOCUMENT  =   'downloadUserDocument'
export const FETCH_USER_REGISTRATION_STATUS  =   'fetchUserRegistrationStatus'
export const USER_REGISTRATION  =   'userRegistration'
export const SAVE_USER_REGISTRATION_STATUS  =   'saveUserRegistrationStatus'
export const SAVE_UPDATE_INBOX_SETTINGS     =   'saveUpdateInboxSettings'
export const FETCH_INBOX_SETTINGS   =   'fetchInboxSettings'
export const CLEAR_INBOX_SETTINGS   =   'clearInboxSettings'
export const FETCH_DOCUMENT   =   'fetchDocument'
export const FETCH_LEARNING_SESSION_DATA  =   'fetchLearningSessionData'
export const FETCH_GROUP_USERS  =   'fetchGroupUsers'
export const FETCH_COMPANY_SETTINGS  =   'fetchCompanySettings'
export const UPDATE_COMPANY_SETTINGS  =   'updateCompanySettings'
export const FETCH_DASHBOARD_DATA   =   'fetchDashboardData'
export const FETCH_DASHBOARD_DOCUMENTS   =   'fetchDashboardDocuments'
export const FETCH_TIME_DATA   =   'fetchTimeData'
export const FETCH_DASHBOARD_QUIZ_DATA   =   'fetchQuizData'
export const FETCH_DASHBOARD_STATS_DATA   =   'fetchDashboardStatsData'




